import { render, staticRenderFns } from "./CalenderIcon.vue?vue&type=template&id=50049181&"
import script from "./CalenderIcon.vue?vue&type=script&lang=ts&"
export * from "./CalenderIcon.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports